export var TpaPageIds;
(function (TpaPageIds) {
    TpaPageIds["product_page"] = "product_page";
    TpaPageIds["blog"] = "blog";
    TpaPageIds["post"] = "post";
    TpaPageIds["forum"] = "forum";
    TpaPageIds["group"] = "group";
    TpaPageIds["bookings"] = "bookings";
})(TpaPageIds || (TpaPageIds = {}));
//# sourceMappingURL=page-mapping.js.map